import { createSlice } from '@reduxjs/toolkit'
import { setWith, get } from 'lodash-es'

//  The state has the following shape:
//
//  stateSlice.namespace.scope.steps
//  stateSlice.namespace.scope.selected
//
//  E.g.
// const stateShapeExample = {
//   "some-namespace": {
//     "some-single-select-scope": {
//       steps: [{ label, value }],
//       selected: "some-value",
//     },
//   "some-multi-select-scope": {
//       steps: [{ label, value }],
//       selected: [value, value]
//   }
// }
const initialState = {}

const selectableSlice = createSlice({
  name: 'selectable',
  initialState,
  reducers: {
    initialize(state, { payload }) {
      const { namespace, scope, value, options } = payload
      const obj = { options, value }
      setWith(state, [namespace, scope], obj, Object)
    },
    changeValue(state, { payload }) {
      const { namespace, scope, value } = payload
      setWith(state, [namespace, scope, 'value'], value, Object)
    },
  },
})

// Selectors

function getBase(state) {
  return get(state, ['selectable'])
}

function getSlice(state, namespace, scope) {
  return get(getBase(state), [namespace, scope])
}

const getOptions = (state, { namespace, scope }) => {
  const slice = getSlice(state, namespace, scope)
  return get(slice, ['options'])
}

const getValue = (state, { namespace, scope }) => {
  const slice = getSlice(state, namespace, scope)
  return get(slice, ['value'])
}

export const selectors = {
  getOptions,
  getValue,
}
export const actions = {
  ...selectableSlice.actions,
}
export default selectableSlice.reducer
